import React from 'react';

const WorklogContext = React.createContext('worklog_context');

export const WorklogContextProvider = WorklogContext.Provider;

export default WorklogContext;
